import styles from "./MedicalSummaryPanelSection.module.css";

interface IMedicalSummaryPanelSectionProps {
    onSectionClick: () => void;
    isSectionOpen: boolean;
    sectionTitle: string;
    children?: React.ReactNode
    cssClass?: string;
}

function MedicalSummaryPanelSection(props: IMedicalSummaryPanelSectionProps): JSX.Element {
    const getSectionIcon = (isSectionOpen: boolean): string => isSectionOpen ? "glyphicon-chevron-up" : "glyphicon-chevron-down";

    return (
        <div key={props.sectionTitle} className={`"summary-panel-section" ${props.isSectionOpen ? "" : "margin-xs-bottom"}`}>
            <div
                className={styles.header}
                data-cy="toggle-section"
                onClick={() => props.onSectionClick()}
            >
                <div className="pull-right">
                    <span className={`glyphicon ${getSectionIcon(props.isSectionOpen)}`} />
                </div>
                <h3>{props.sectionTitle}</h3>
            </div>
            {props.isSectionOpen && (
                <div className={`${styles.content} ${styles[props.cssClass] ?? ""}`}>
                    {props.children}
                </div>
            )}
        </div>
    );
}

export { MedicalSummaryPanelSection };
